<app-invoice-list [list]="list" [uploadEnabled]="caseNumber" [downloadEnabled]="caseNumber" 
  [hasInternationalCurrency]="hasInternationalCurrency" [firmCurrencyCode]="firmCurrencyCode" 
  [caseCurrencyCode]="caseCurrencyCode" (invoiceCopyRequested)="openInvoiceCopy($event)"
  (invoicesDownloadRequested)="downloadInvoices()" [numberFormat]="numberFormat">
</app-invoice-list>

@if(uploadEnabled)
{
  <app-file-upload #filesInput (fileToUploadChange)="handleSelectedFiles(filesPopup, $event)" 
    [multiFile]="true" [icon]="false" fileInputId="casInvoiceCopy" name="invoiceUpload" [displayFilesList]="false"
    [fileType]="'invoice'" [customTemplate]="true">
    <button class="button-basic" (click)="filesInput.selectFile()" >
        {{'Case.Invoices.AddInvoice' | translate}}
    </button>
  </app-file-upload>
}

<ng-template #filesPopup let-data>
  <div mat-dialog-title></div>
  @if(data.files; as files)
  {
    <div mat-dialog-content>
      <table class="table">
        <thead>
          <th>{{'Case.Invoice.Number' | translate}}</th>
          <th>{{'Case.Invoice.FileName' | translate}}</th>
        </thead>
        <tbody>
          @for(invoice of data.invoices; track invoice.id)
          {
            <tr>
              <td>{{invoice.number}}</td>
              <td>
                <custom-select [options]="fileNames" [(selectedKey)]="invoice.fileIndex">
                </custom-select>
                <i style="margin-left: 1rem;"
                  [ngClass]="{ 'fas': true, 'fa-spinner fa-spin': invoice.status == 'busy', 'fa-check success': invoice.status == 'success', 'fa-times error': invoice.status == 'error'}"></i>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  
    <mat-dialog-actions>
      <div class="buttons-container">
        <button class="button-basic-reverse" mat-raised-button mat-dialog-close>
          {{'General.Cancel' | translate}}
        </button>
        <button class="button-basic" (click)="upload(data.invoices, files)" mat-raised-button >
          {{'General.Save' | translate}}
        </button>
      </div>
    </mat-dialog-actions>
  }
</ng-template>
